module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#action",
      toString: function () {
        return this.url;
      }
    }